// extracted by mini-css-extract-plugin
export default {"tab":"AuditorDetailsEdit_tab__Y2hif","auditorHeader":"AuditorDetailsEdit_auditorHeader__rq2pZ","auditorCard":"AuditorDetailsEdit_auditorCard__8e-4B"};